import { Component, OnInit, inject } from '@angular/core';

import { CommonModule } from '@angular/common';

import { Firestore, collection, collectionData, CollectionReference, addDoc  } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

import { FootComponent } from '../../components/foot/foot.component';
import { HeadComponent } from '../../components/head/head.component';

export interface Fewalbums { 
  id: string;
  img: string; 
  hrf: string;
  name: string;
  title: string;
}

@Component({
  selector: 'app-b240',
  standalone: true,
  imports: [
    CommonModule,
    HeadComponent,
    FootComponent
  ],
  templateUrl: './b240.component.html',
  styleUrls: ['./b240.component.scss']
})
export class B240Component implements OnInit {

  /*stands = [
    { img:'../../../assets/Image/FUNDIVE/L1120.png',hrf:'https://www.facebook.com/janicewa2002',name:'墾丁', title:'2021 / 11 / 20 ~ 21' },
    { img:'../../../assets/Image/FUNDIVE/L1105.png',hrf:'https://www.facebook.com/janicewa2002',name:'墾丁', title:'2021 / 11 / 20 ~ 21' },
    { img:'../../../assets/Image/FUNDIVE/L1102.png',hrf:'https://www.facebook.com/janicewa2002',name:'墾丁', title:'2021 / 11 / 20 ~ 21' },
    { img:'../../../assets/Image/FUNDIVE/L1030.png',hrf:'https://www.facebook.com/janicewa2002',name:'墾丁', title:'2021 / 11 / 20 ~ 21' }
  ]*/

  private firestore = inject(Firestore);

  private fewalbumsRef = collection(this.firestore, 'iDiving/activity/fewalbums') as CollectionReference<Fewalbums>;
  fewalbumsitems$: Observable<Fewalbums[]> = collectionData(this.fewalbumsRef, { idField: 'id' });

  addItem(fewalbums: Fewalbums) {
    return addDoc(this.fewalbumsRef, fewalbums);
  }

  ngOnInit(): void {
  }

}
